module.exports = __webpack_public_path__ + "assets/logo-gold.7c8a1d9e.svg";